import React from 'react'
import { Box } from '@chakra-ui/react'

const Section = props => {
  return <Box as="section" {...props} />
}

Section.defaultProps = {
  py: [9, 9, 12, 16],
}

Section.displayName = 'Section'

export default Section
